// src/components/homepage/RentCube.jsx
import React from "react";
import { motion } from "framer-motion"; // ✅ Import framer-motion
import { Link } from "react-router-dom";
import greatDeals from "../../assets/images/greatDeals.png";

const GreatDeals = () => {
  return (
    <div className="mx-2 lg:container">
      <motion.div
        initial={{ opacity: 0, y: 50 }} // Start faded + shifted down
        whileInView={{ opacity: 1, y: 0 }} // Animate into view
        transition={{ duration: 0.8, ease: "easeOut" }} // Smooth animation
        viewport={{ once: true }} // Animate only once
        className="bg-[#FFF9ED] mt-12 rounded-xl container"
      >
        <div className="mx-auto flex flex-col md:flex-row items-center gap-10 py-12 px-2 md:px-4 lg:px-12">
          {/* Text Section */}
          <div className="flex-1 text-left md:text-left">
            <p className="text-agBlack text-xl mb-2 md:mb-4">
              SHOP TRUSTED PRODUCTS
            </p>
            <div className="text-agBlack uppercase font-semibold text-xs mb-2 bg-[#F8DDA6] py-1 px-4 rounded-md w-24 mb-8 md:mb-16 lg:mb-24">
              SHOPPERS
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-agBlack leading-tight mb-2">
              Verified Vendors,
              <br />
              Great Deals
            </h2>
            <p className="text-agLightGray font-light text-sm md:text-lg mb-8">
              Browse quality products from trusted vendors. Shop confidently —
              with real reviews and buyer protection.
            </p>

            <Link to="/shop">
              <p className="bg-agGreen text-agBlue py-3 rounded-full text-sm md:text-lg font-medium transition">
                Shop Now →
              </p>
            </Link>
          </div>

          {/* Image Section */}
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
            viewport={{ once: true }}
            className="hidden md:block md:flex-1 md:flex md:justify-center"
          >
            <img
              src={greatDeals}
              alt="Cubes"
              className="w-full max-w-md md:max-w-lg"
            />
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default GreatDeals;

// // src/components/homepage/RentCube.jsx
// import React from "react";
// import { motion } from "framer-motion"; // ✅ Import framer-motion
// import { Link } from "react-router-dom";
// import greatDeals from "../../assets/images/greatDeals.png";

// const GreatDeals = () => {
//   return (
//     <div className="container">
//       <motion.div
//         initial={{ opacity: 0, y: 50 }} // Start faded + shifted down
//         whileInView={{ opacity: 1, y: 0 }} // Animate into view
//         transition={{ duration: 0.8, ease: "easeOut" }} // Smooth animation
//         viewport={{ once: true }} // Animate only once
//         className="bg-[#FFF9ED] my-8 rounded-xl container mx-4"
//       >
//         <div className="mx-auto flex flex-col md:flex-row items-center gap-10 py-12 px-2 md:px-4 lg:px-12">
//           {/* Text Section */}
//           <div className="flex-1 text-left md:text-left">
//             <p className="text-agBlack text-xl mb-2 md:mb-4">
//               SHOP TRUSTED PRODUCTS
//             </p>
//             <div className="text-agBlack uppercase font-semibold text-xs mb-2 bg-[#F8DDA6] py-1 px-4 rounded-md w-24 mb-8 md:mb-16 lg:mb-24">
//               SHOPPERS
//             </div>
//             <h2 className="text-3xl md:text-5xl font-bold text-agBlack leading-tight mb-2">
//               Verified Vendors,
//               <br />
//               Great Deals
//             </h2>
//             <p className="text-agLightGray font-light text-sm md:text-lg mb-8">
//               Browse quality products from trusted vendors. Shop confidently —
//               with real reviews and buyer protection.
//             </p>

//             <Link to="/shop">
//               <p className="bg-agGreen text-agBlue py-3 rounded-full text-sm md:text-lg font-medium transition">
//                 Shop Now →
//               </p>
//             </Link>
//           </div>

//           {/* Image Section */}
//           <motion.div
//             initial={{ scale: 0.8, opacity: 0 }}
//             whileInView={{ scale: 1, opacity: 1 }}
//             transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
//             viewport={{ once: true }}
//             className="hidden md:block md:flex-1 md:flex md:justify-center"
//           >
//             <img
//               src={greatDeals}
//               alt="Cubes"
//               className="w-full max-w-md md:max-w-lg"
//             />
//           </motion.div>
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// export default GreatDeals;
